<template>
  <div>
    <!--     
    <DxDropDownBox
      v-model:value="gridBoxValue"
      v-model:opened="isGridBoxOpened"
      :defer-rendering="false"
      :show-clear-button="true"
      :data-source="filterValueDataSource"
      display-expr="name"
      placeholder="Select a value..."
      @valueChanged="filterValueChanged"
    >
      <template #content="{ data }">
        <DxDataGrid
          :columns="gridColumns"
          :data-source="filterValueDataSource"
          :show-borders="true"
          :showRowLines="true"
          :remote-operations="true"
          :hover-state-enabled="true"
          v-model:selected-row-keys="gridBoxValue"
          height="100%"
        >
          <DxSelection mode="multiple" />
          <DxFilterRow :visible="true" />
          <DxGroupPanel :visible="true" />
          <DxGrouping :auto-expand-all="false" />
          <DxPaging :page-size="10" />
          <DxPager
            :visible="true"
            display-mode="full"
            :show-page-size-selector="false"
            :show-info="true"
            :show-navigation-buttons="true"
          />
        </DxDataGrid>
      </template>
    </DxDropDownBox> -->

    <DxTagBox
      :data-source="gridDataSource"
      display-expr="name"
      value-expr="label"
      :value="selectedTags"
      @valueChanged="filterValueChanged"
      :search-enabled="true"
    >
    </DxTagBox>

    <!-- <DxTagBox
    :dataSource="testData"
     display-expr="value"
    value-expr="key"
    :value="selectedValues"
  ></DxTagBox> -->
  </div>
</template>

<script>
import { DxSelectBox } from "devextreme-vue/select-box";
import CustomStore from "devextreme/data/custom_store";
import DxTagBox from "devextreme-vue/tag-box";

import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";

export default {
  props: {
    rRoute: String,
    fieldName: {
      type: Object,
      default: () => ({}),
    },
    datasource: {
      type: Object,
      default: () => ({}),
    },
    slug: String,
    modelValue: String,
    fieldValue: String,
  },
  components: {
    DxTagBox,
    DxSelectBox,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxGrouping,
    DxGroupPanel,
    DxDropDownBox,
  },
  data() {
    return {
      gridDataSource: this.datasource,
      filterValueDataSource: this.datasource,
      gridBoxValue: "",
      searchModeOption: "contains",
      searchExprOption: "name",
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      multilabel: "label",
      showDataBeforeSearchOption: true,
      selectedTags: "",
    };
  },
  methods: {
    makeAsyncDataSource(rRoute, slug) {
      return new CustomStore({
        key: "id",
        loadMode: "processed",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/list";

          //  let listurl = "/" + slug + "/" + rRoute + "/field/rlt_fld_build_relate";

          // console.log("RELATE COMPONENT hello");

          var parameters = {};
          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }
          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              console.log("RELATE COMPONENT", response.data.results.data);
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {
           if (key !== null && key !== undefined && key !== "") {
            let url = "/" + slug + "/" + rRoute + "/getById/" + key;
            return axios
              .get(url)
              .then((response) => {
                return {
                  id: response.data.data.id,
                  name: response.data.data.name,
                };
              })
              .catch(() => {
                throw "Data Loading Error";
              });
          }

          //return { id: key, name: "Unknown" };
        },
      });
    },
    filterValueChanged(e) {
      let strValue = JSON.stringify(e.value);
      // console.log("Multi Value Changed", e.value);
      this.$emit("update:modelValue", strValue);
    },
  },
  mounted() {
   // console.log("Multi Select Component datasource", this.datasource);
   // console.log("Multi Select Component fieldValue", this.fieldValue);
   // console.log("Multi Select Component modelValue", this.modelValue);

    if (typeof this.modelValue !== "undefined") {
      this.selectedTags = JSON.parse(this.modelValue);
    }
   // this.gridDataSource = this.datasource;

    

    //this.gridBoxValue = this.modelValue;

    //this.gridDataSource = this.makeAsyncDataSource(this.rRoute, this.slug);
    //this.gridBoxValue={id:"d91433edfba944cf82e4af56cabf906c",name:"Rahul"};
    //this.gridBoxValue="d91433edfba944cf82e4af56cabf906c";
    //console.log(this.$refs["rltfld"].instance.getValue());
  },
};
</script>

<style>
</style>